import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { InformationHeroBanner } from "../../blocks/InformationHeroBanner";
import { toolboxComponentsMap } from "../../blocks/toolboxComponentsMap";

import styles from "./index.module.scss";

/**
 * sealy ReviewsPage body assembly (#33585): ``ReviewsPageBodyContent`` = the
 * 30 Toolbox keys + ``hero_banner`` (``InformationHeroBanner``, the same
 * block the InformationPage assembly dispatches -- a real ported component
 * as of #33285 batch B; no legacy HTML-string keys remain here).
 *
 * The full-document ReviewsPageTemplate renders the love-root breadcrumb
 * chrome above this body and passes the reviews SPA as ``children``, which
 * renders below the body loop inside the all-reviews wrapper.
 *
 * FAITHFUL port of the legacy ``cms/reviews_page.html`` body render (verified
 * at git dev): a bare ``{% for %}{% include_block %}`` loop -- NO per-block
 * Wagtail ``w-block-*`` wrapper, reproduced with
 * ``tagName={React.Fragment}``.
 */
export const reviewsPageComponentsMap = {
    ...toolboxComponentsMap,
    hero_banner: InformationHeroBanner,
} as const;

export const ReviewsPageBody = (
    props: Immutable<{
        page: Pick<templates.ReviewsPageDocumentTemplate["page"], "body">;
        children: React.ReactNode;
    }>,
): React.JSX.Element => {
    // `body` is non-null (the model field is `blank=True` without
    // `null=True`); an empty stream renders no blocks.
    return (
        <>
            <StreamField
                tagName={React.Fragment}
                value={props.page.body.value}
                components={reviewsPageComponentsMap}
            />
            <div className="customer-review">
                <section
                    className={concatClassNames([
                        styles.allReviews,
                        "l-capped-width",
                    ])}
                >
                    {props.children}
                </section>
            </div>
        </>
    );
};
